export class ImageService {
    // Converts a data URL(e.g., "data:image/png;base64,...") to a Blob
    public static dataUrlToBlob(dataUrl: string): Blob {
        const [header, base64] = dataUrl.split(',');
        const mimeMatch = header.match(/data:(.*);base64/);
        if (!mimeMatch) {
            throw new Error('Invalid data URL');
        }
        const mime = mimeMatch[1];
        const binary = atob(base64);
        const len = binary.length;
        const buffer = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            buffer[i] = binary.charCodeAt(i);
        }
        return new Blob([buffer], { type: mime });
    }


    //  Converts a data URL to a File object

    public static dataUrlToFile(dataUrl: string, filename: string): File {
        const blob = ImageService.dataUrlToBlob(dataUrl);
        return new File([blob], filename, { type: blob.type });
    }
}

export default ImageService; 